var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "selector-group" }, [
    _c("label", { staticClass: "selector-label" }, [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.closeDropdown,
            expression: "closeDropdown"
          }
        ],
        staticClass: "custom-select-wrapper"
      },
      [
        _c(
          "div",
          {
            staticClass: "custom-select-trigger",
            class: { "is-disabled": _vm.disabled },
            on: { click: _vm.onTriggerClick }
          },
          [
            _c("span", { staticClass: "placeholder" }, [
              _vm._v(_vm._s(_vm.placeholder))
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "arrow", class: { "is-open": _vm.isOpen } },
              [_vm._v("❮")]
            )
          ]
        ),
        _vm._v(" "),
        _vm.isOpen
          ? _c("div", { staticClass: "custom-select-dropdown" }, [
              _c("div", { staticClass: "search-input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchQuery,
                      expression: "searchQuery"
                    }
                  ],
                  ref: "searchInput",
                  staticClass: "search-input",
                  attrs: { type: "text", placeholder: _vm.searchPlaceholder },
                  domProps: { value: _vm.searchQuery },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchQuery = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-select-options" },
                [
                  _vm._l(_vm.filteredOptions, function(option) {
                    return _c(
                      "div",
                      {
                        key: option.id,
                        staticClass: "custom-select-option",
                        class: { "is-selected": _vm.isSelected(option.id) },
                        on: {
                          click: function($event) {
                            return _vm.onOptionClick(option)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(option.name) + "\n        "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.filteredOptions.length === 0 && _vm.searchQuery.length > 0
                    ? _c(
                        "div",
                        { staticClass: "custom-select-option is-empty" },
                        [
                          _vm._v(
                            "\n          No se encontraron resultados\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filteredOptions.length === 0 &&
                  _vm.searchQuery.length === 0
                    ? _c(
                        "div",
                        { staticClass: "custom-select-option is-empty" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.emptyMessage) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              )
            ])
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.selectedItems.length > 0
      ? _c(
          "div",
          { staticClass: "selector-pills" },
          _vm._l(_vm.selectedItems, function(pill) {
            return _c(
              "span",
              {
                key: "pill-" + pill.id,
                staticClass: "pill",
                class: _vm.pillClass
              },
              [
                _vm._v("\n      " + _vm._s(pill.name) + "\n      "),
                _c(
                  "button",
                  {
                    staticClass: "pill-remove",
                    on: {
                      click: function($event) {
                        return _vm.onRemovePill(pill)
                      }
                    }
                  },
                  [_vm._v("×")]
                )
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }